import React,{useState,useEffect} from 'react';
import Axios from 'axios';
import ConfirmDialog from '../ui-elements/ConfirmDialog';

const NoteTile=({noteId,noteTitle,noteContent,noteType,noteTopic,noteTime,modalFunc,webToken,noteFetchFunc,isNotesModal})=>{
    const [showMore, setShowMore]=useState(false);
    const [showMoreBtnText, setShowMoreBtnText]=useState("Show more");
    const [topicLink,setTopicLink]=useState(null);
    const [showConfirm, setShowConfirm]=useState(false);

    const handleShowMore=()=>{
        setShowMore(!showMore);
    }

    const deleteAlimNote=()=>{
        Axios.post(`${alimAPIBaseURI}rpc/delete_alim_note`, {noteid:noteId},{headers: {"Content-Type": "application/json","Authorization":`bearer ${webToken}`}}).then((data)=>{
            console.log(data.data);
            setShowConfirm(false);
            noteFetchFunc(1);
        }).catch((error)=>{
            console.log(error);
            setShowConfirm(false);
            showAlert("Something went wrong.", "warn");
        });
    }

    const getNoteCatagory=(noteType)=>{
        let noteCatagory="";

        if (["ARB", "RCT", "ASD", "MKT", "MAL", "PIK", "YAT", "CMP", "TIK", "MDD"].includes(noteType)) {
            noteCatagory="quran";
        }
        else if (["AMH", "FQS", "SHB", "NWH", "TIR", "HDQ", "SAD", "NAS", "MAJ", "SHM"].includes(noteType)) {
            noteCatagory="hadith";
        }
        else
        {
            noteCatagory="history";
        }

        return noteCatagory;
    }

    const getQuranURI=(category,snum,anum)=>{
        let navLink="";
        switch(category){
            case "ARB": navLink={uri: `/quran/read-surah/${snum}?qRef=${anum}`, label:`Al-Quran Translation`}; break;
            case "RCT": navLink={uri: `/quran/recite-surah/${snum}?qRef=${anum}`, label:`Al-Quran Recitation`}; break;
            case "ASD": navLink={uri: `/translation/asad/${snum}`, label:`Asad Translation`}; break;
            case "MKT": navLink={uri: `/translation/khattab/${snum}`, label:`Khattab Translation`}; break;
            case "MAL": navLink={uri: `/translation/malik/${snum}`, label:`Malik Translation`}; break;
            case "PIK": navLink={uri: `/translation/picktal/${snum}`, label:`Picktal Translation`}; break;
            case "YAT": navLink={uri: `/translation/yusuf-ali/${snum}`, label:`Yusuf Ali Translation`}; break;
            case "CMP": navLink={uri: `/quran/compare/surah/${snum}/${anum}/`, label:`Compare Translation`}; break;
            case "TIK": navLink={uri: `/quran/tafsir/ibn-kathir/surah/${snum}/?ayah=${anum}`, label:`Ibn Kathir Tafsir`}; break;
            case "MDD": navLink={uri: `/quran/tafsir/maududi/surah/${snum}/?ayah=${anum}`, label:`Maududi Tafsir`}; break;
            default: navLink="#";break;
        }
        return navLink;
    }

    const getHadithURI=(category,volume,book,hadith)=>{
        let linkStr="";
        switch(category){
            case "AMH": linkStr={uri: `/hadith/al-muwatta/${volume}/${hadith}`, label:`Al-Muwatta Hadith`}; break;
            case "FQS": linkStr={uri: `/hadith/fiqh-us-sunnah/${volume}/${hadith}`, label:`Fiqh-us-Sunnah Hadith`}; break;
            case "SHB": linkStr={uri: `/hadith/sahih-bukhari/${volume}/${book}/${hadith}`, label:`Sahih Bukhari Hadith`}; break;
            case "NWH": linkStr={uri: `/hadith/nawawi/${hadith}`, label:`Nawawi Hadith`}; break;
            case "TIR": linkStr={uri: `/hadith/tirmidi/${book}/${hadith}`, label:`Al-Tirmidhi Hadith`}; break;
            case "HDQ": linkStr={uri: `/hadith/qudsi/${hadith}`, label:`Qudsi Hadith`}; break;
            case "SAD": linkStr={uri: `/hadith/sunan-of-abu-dawood/${book}/${hadith}`, label:`Sunan of Abu Dawood Hadith`}; break;
            case "NAS": linkStr={uri: `/hadith/sunan-an-nasai/${book}/${hadith}`, label:`Sunan an-Nasai Hadith`}; break;
            case "MAJ": linkStr={uri: `/hadith/sunan-ibn-majah/${book}/${hadith}`, label:`Sunan Ibn Majah Hadith`}; break;
            case "SHM": linkStr={uri: `/hadith/sahih-muslim/${book}/${hadith}`, label:`Sahih Muslim Hadith`};break;
            default: linkStr=category;break;
        }
        return linkStr;
    }

    const getBaseAPIURI=(category)=>{
        let apiStr="";
        switch(category){
            case "ABI": apiStr={uri: `/api/history/about-islam/`, label:`About Islam`}; break;
            case "KAB": apiStr={uri: `/api/history/khalifa-abu-bakr/`, label:`Khalifa Abu Bakr`}; break;
            case "KUM": apiStr={uri: `/api/history/khalifa-umar/`, label:`Khalifa Umar`}; break;
            case "KUT": apiStr={uri: `/api/history/khalifa-uthman/`, label:`Khalifa Uthman`}; break;
            case "KAL": apiStr={uri: `/api/history/khalifa-ali/`, label:`Khalifa Ali`}; break;
            case "BIO": apiStr={uri: `/api/history/prophet-companions/meta/`, label:`Prophets Companions`}; break;
            case "SOP": apiStr={uri: `/api/history/prophet-stories/meta/`, label:`Stories of Prophet`};break;
            case "TIL": apiStr={uri: `/api/history/islamic-timeline/`, label:`Islamic history timeline`};break;
            case "DI": apiStr={uri: `/api/history/islam-posters/`, label:`Islamic Posters`};break;
            default: apiStr=category;break;
        }
        return apiStr;
    }

    const getURLStr=(data)=>{
        let str = data;
        str = str.replace(/\W+(?!$)/g, '-').toLowerCase();
        str = str.replace(/\W$/, '').toLowerCase();
        return str;
    }

    const getHistoryURI = async (comment_cat, sec_num) => {
        let navLink = "#";
    
        try {
            const data = await Axios.get(`${getBaseAPIURI(comment_cat).uri}${sec_num}/data.json`, {
                headers: { "Content-Type": "application/json" }
            });
    
            const secName = data.data.Name;
    
            if (comment_cat === "BIO" || comment_cat === "SOP" || comment_cat === "DI") {
                const apiLink = getBaseAPIURI(comment_cat).uri;
                navLink = `/${apiLink.split('/')[2]}/${apiLink.split('/')[3]}/${sec_num}`;
            } else if (comment_cat === "ABI") {
                const apiLink = getBaseAPIURI(comment_cat).uri;
                navLink = `/${apiLink.split('/')[2]}/about/islam/${getURLStr(secName)}`;
            } else {
                const apiLink = getBaseAPIURI(comment_cat).uri;
                navLink = `/${apiLink.split('/')[2]}/${apiLink.split('/')[3]}/${getURLStr(secName)}`;
            }
        } catch (error) {
            console.log(error);
        }

        const finalLink = {uri:navLink, label:getBaseAPIURI(comment_cat).label};
    
        return finalLink; // Return the navLink after the API call is done
    };

    const getSectionURI=(noteType,noteRef)=>{
        const noteCatagory=getNoteCatagory(noteType);
        if(noteCatagory==="quran")
        {
            const surahNum = noteRef.match(/S(\d+)/)[1];
            const ayahMatch = noteRef.match(/A(\d+)/);
            const ayahNum = ayahMatch ? ayahMatch[1] : 1;
            const navLink=getQuranURI(noteType,surahNum,ayahNum);
            setTopicLink(navLink);
        }
        else if(noteCatagory==="hadith")
        {
            const volumeNum = noteRef.match(/V(\d+)/)[1];
            const bookNum = noteRef.match(/B(\d+)/)[1];
            const hadithNum = noteRef.match(/H(\d+)/)[1];
            const navLink=getHadithURI(noteType,volumeNum,bookNum,hadithNum);
            setTopicLink(navLink);
        }
        else
        {
            const sectionNum = noteRef.match(/S(\d+)/)[1];
            (async () => {
                const navLink = await getHistoryURI(noteType, sectionNum);
                setTopicLink(navLink);
            })();
        }
    }

    useEffect(()=>{
        showMore?setShowMoreBtnText("Show less"):setShowMoreBtnText("Show more")
    },[showMore]);

    useEffect(()=>{},[topicLink]);

    useEffect(()=>{
        if(noteType&&noteTopic)
        {
            getSectionURI(noteType,noteTopic);
        }
    },[]);

    return(
        <div className={`bg-light-beige ${isNotesModal==="1"?`dark:bg-deep-blue`:`dark:bg-light-blue`} border border-light-beige dark:border-light-blue rounded-lg px-5 py-3 col-span-12 md:col-span-6`}>
            <h4 className='font-light text-xl'>{noteTitle}</h4>
            {
                topicLink!==null?
                    <a href={topicLink.uri} className='flex gap-2 hover:underline mt-1.5 w-fit' title='Goto topic'>
                        <span className='text-xs'>Posted in {topicLink.label} - {noteTime ?? 'Just now'}</span>
                    </a>
                :
                    null
            }
            <div className='min-h-[116px]'>
                <p className={`mt-4 text-sm ${noteContent.length>150?"mb-1":"mb-4"}`}>
                    {
                        noteContent.length>150?showMore?noteContent:noteContent.substring(0, 150)+"...":noteContent
                    }
                </p>
                {noteContent.length>150?<button className='text-sm mb-4 underline' onClick={handleShowMore}>{showMoreBtnText}</button>:null}
            </div>
            
            <div className='flex justify-end'>
                <div className='flex gap-3 cursor-pointer items-center' title='Edit this note'>
                    <button className='flex gap-2' onClick={()=>{modalFunc(noteId,noteTitle,noteContent)}}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                        </svg>
                    </button>
                    <button className='flex gap-2' onClick={()=>{setShowConfirm(true)}}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                        </svg>
                    </button>
                    {
                        topicLink!==null?
                            <a href={topicLink.uri} className='flex gap-2' title='Goto topic'>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                                </svg>
                            </a>
                        :
                            null
                    }
                </div>
            </div>
            {
                showConfirm&&<ConfirmDialog cancelFunc={setShowConfirm} confirmFunc={deleteAlimNote}>
                    <h3 className="mb-2 text-lg font-normal alim-text-color-style">Delete this note?</h3>
                    <p className='text-sm alim-text-color-style mb-5'>Please be advised that deleting the note is irreversible.</p>
                </ConfirmDialog>
            }
        </div>
    );
}

export default NoteTile;